import { useEffect, useState } from "react";
import { Gift, Copy, Share2, Mail, Facebook } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";

const Stat = ({ n, label, testId }) => (
  <div className="rounded-2xl bg-white/80 px-3 py-2 text-center"><p className="font-display text-2xl text-[#2C4A3E]" data-testid={testId}>{n}</p><p className="text-[11px] text-stone-500">{label}</p></div>
);

export const ShareEarn = () => {
  const [r, setR] = useState(null);
  useEffect(() => { http.get("/referrals/me").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r?.code) return null;
  const link = `${window.location.origin}/register?ref=${r.code}`;
  const text = "We love ConsciousLearn for mindful K-12 learning. Use my link for an extra free week, and your first month free when you subscribe:";
  const copy = () => { navigator.clipboard?.writeText(link); toast.success("Link copied"); };
  const share = () => (navigator.share ? navigator.share({ title: "ConsciousLearn", text, url: link }).catch(() => {}) : copy());
  const btn = "inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-white border border-[#E6DEC3] text-xs text-[#2C4A3E] hover:bg-[#F1EADB]";
  return (
    <section className="rounded-3xl bg-[#FBF3E2] border border-[#F2D49B] p-6" data-testid="share-earn-card">
      <p className="font-display text-xl text-[#2C4A3E] flex items-center gap-2"><Gift className="w-5 h-5 text-[#C87D53]" />Share and earn</p>
      <p className="text-xs text-stone-600 mt-1">Friends get an extra free week plus their first month free. You get a free month after each friend's first payment.</p>
      <div className="mt-4 flex items-center gap-2 rounded-full bg-white border border-[#E6DEC3] pl-4 pr-1 py-1">
        <span className="text-xs text-stone-600 truncate flex-1 min-w-0" data-testid="share-earn-link">{link}</span>
        <button onClick={copy} data-testid="share-earn-copy" aria-label="Copy link" className="p-2 rounded-full bg-[#2C4A3E] text-white"><Copy className="w-3.5 h-3.5" /></button>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <button onClick={share} data-testid="share-earn-share" className={btn}><Share2 className="w-3.5 h-3.5" />Share</button>
        <a href={`mailto:?subject=${encodeURIComponent("Try ConsciousLearn with us")}&body=${encodeURIComponent(`${text} ${link}`)}`} data-testid="share-earn-email" className={btn}><Mail className="w-3.5 h-3.5" />Email</a>
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`} target="_blank" rel="noreferrer" data-testid="share-earn-facebook" className={btn}><Facebook className="w-3.5 h-3.5" />Facebook</a>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-2">
        <Stat n={r.joined} label="Joined" testId="share-earn-joined" />
        <Stat n={r.subscribed} label="Subscribed" testId="share-earn-subscribed" />
        <Stat n={r.months_earned} label="Free months" testId="share-earn-months" />
      </div>
      {r.credits > 0 && <p className="mt-3 text-xs text-[#7A4A12]" data-testid="share-earn-credits">{r.credits} free month{r.credits > 1 ? "s" : ""} waiting, applied at your next checkout.</p>}
    </section>
  );
};
